import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { isValidEmail } from '../../lib/utils';

const API_URL = '';

export const NewsletterPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('bloom_newsletter_popup');
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem('bloom_newsletter_popup', 'true');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!isValidEmail(email)) {
      setError('Veuillez entrer une adresse email valide');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch(`${API_URL}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        setStatus('success');
        localStorage.setItem('bloom_newsletter_popup', 'true');
        setTimeout(() => setIsOpen(false), 2000);
      } else {
        setError('Une erreur est survenue. Veuillez réessayer.');
        setStatus('idle');
      }
    } catch (err) {
      setError('Une erreur est survenue. Veuillez réessayer.');
      setStatus('idle');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="newsletter-popup animate-slideUp" data-testid="newsletter-popup">
      <button
        onClick={handleClose}
        className="absolute top-4 right-4 p-1 hover:bg-[#F4E3E1] rounded-full transition-colors"
        data-testid="close-newsletter-btn"
      >
        <X size={16} />
      </button>

      <div className="text-center mb-4">
        <h3 className="font-serif text-2xl mb-2">Bienvenue chez Bloom</h3>
        <p className="text-sm text-[#6B6A68]">
          Inscris-toi et reçois 10% sur ta première commande
        </p>
      </div>

      {status === 'success' ? (
        <div className="text-center py-4">
          <p className="text-[#A3B19B] font-medium">Merci pour ton inscription!</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Ton adresse email"
            className="checkout-input mb-4"
            data-testid="newsletter-email-input"
          />
          {error && <p className="text-xs text-[#C87979] mb-3">{error}</p>}
          <button
            type="submit"
            disabled={status === 'loading'}
            className="btn-primary w-full py-3 text-sm font-medium disabled:opacity-50"
            data-testid="newsletter-submit-btn"
          >
            {status === 'loading' ? 'Inscription...' : "S'inscrire"}
          </button>
        </form>
      )}

      <p className="text-xs text-[#6B6A68] text-center mt-4">
        En t'inscrivant, tu acceptes de recevoir nos emails marketing.
      </p>
    </div>
  );
};
